<div class="item item--signed" [ngClass]="{ darkmode: isDarkmode }">
  <div class="item-head">
    <span class="item-head-contact blured">{{ 'whitelabel.creator' | translate }}></span>
  </div>
  <div class="item-content">
    <div class="item-content-avatar blured"></div>
    <div class="item-content-data">
      <div class="item-content-name blured">{{ 'whitelabel.personName' | translate }}</div>
      <div class="item-content-name blured">{{ 'whitelabel.secondLine' | translate }}</div>
      <div class="item-content-links"></div>
    </div>
  </div>
  <div class="item-info-holder">
    <div class="item-info" [class.active]="true">
      <div class="item-info-icon">
        <i class="fal fa-check"></i>
      </div>
      <div class="item-content-data">
        <div class="item-content-name blured">{{ 'whitelabel.createdDocument' | translate }}</div>
        <div class="item-content-name blured">{{ 'whitelabel.largerSecondLine' | translate }}</div>
      </div>
    </div>
  </div>
</div>
